import AbstractModel from './AbstractModel';

class FileModel extends AbstractModel {}

export default FileModel;
